import type { TOC } from '@ember/component/template-only'
import { SideNavAccordionList, SideNavAccordionItem } from 'teacher-ui-client/components/side-nav/accordion'
import { t } from 'ember-intl'
import { hash } from '@ember/helper'
import { SchoolClassOptionTypes } from 'teacher-ui-client/components/base/select/school-class/options'
import bookReaderUnfilled from '@images/icons/book-reader-unfilled.svg'

export const BookLibraryAccordion: TOC<unknown> = <template>
  <SideNavAccordionList
    @iconUrl={{bookReaderUnfilled}}
    @iconAlt="Sidenav book"
    @label={{t "sideNav.reading.teacherLibrary"}}
  >
    <SideNavAccordionItem @route="subscription-type.book-library.search">
      {{t "bookLibrary.pages.search.name"}}
    </SideNavAccordionItem>
    <SideNavAccordionItem @route="subscription-type.book-library.collection">
      {{t "bookLibrary.pages.collections.name"}}
    </SideNavAccordionItem>
    <SideNavAccordionItem
      @route="subscription-type.book-library.shares.index.by-collection"
      @query={{hash schoolClassId=SchoolClassOptionTypes.My}}
      @currentWhen="subscription-type.book-library.shares"
    >
      {{t "bookLibrary.pages.sharedCollections.name"}}
    </SideNavAccordionItem>
  </SideNavAccordionList>
</template>

export default BookLibraryAccordion
